import * as qsLib from 'qs';

import { handlePagerDutyApiResponse } from 'src/lib/api/handlePagerDutyApiResponse';
import { getEnvironment } from 'src/lib/featureFlags';

import baseApi from '../baseApi';

class Integration {
  constructor() {
    this.baseUrl = getEnvironment().integrationServiceBaseUrl;
    this.pdSession = {};
  }

  configure({ apiBaseUrl, appBaseUrl, accountBaseUrl, accessToken }) {
    this.pdSession = { apiBaseUrl, appBaseUrl, accountBaseUrl, accessToken };
  }

  _request({ method, url, body, headers, qs }) {
    url = `${this.baseUrl}${url}`;

    let query = qsLib.stringify(qs, { arrayFormat: 'brackets' });
    if (query) {
      if (url.includes('?')) url = `${url}&${query}`;
      else url = `${url}?${query}`;
    }

    headers = headers || {};
    if (this.pdSession.accessToken) {
      headers.Authorization = `Bearer ${this.pdSession.accessToken}`;
    }

    headers['X-PagerDuty-Environment'] = JSON.stringify(
      {
        apiBaseUrl: this.pdSession.apiBaseUrl,
        appBaseUrl: this.pdSession.appBaseUrl,
        accountBaseUrl: this.pdSession.accountBaseUrl
      });

    return baseApi
      .regularRequest(method, url, body, headers)
      .then(handlePagerDutyApiResponse);
  }

  async getProjectIssueTypes(accountsMappingId, serviceId) {
    return this._request({
      url: `/project_issue_types?accounts_mapping_id=${accountsMappingId}&service_id=${serviceId}`,
      method: 'GET',
    });
  }

  async createIssue(accountsMappingId, incident, issue, user) {
    return this._request({
      url: `/create_issue_from_pagerduty`,
      method: 'POST',
      body: {
        accounts_mapping_id: accountsMappingId,
        incident,
        issue,
        reporter: {
          id: user.id,
          type: 'user_reference',
          email: user.email,
          summary: user.summary,
          self: user.self,
          html_url: user.html_url,
        },
      },
    });
  }
}

window.__pd_ui_integration_client = window.__cy_stub_pd_ui_integration_client || new Integration();
export default window.__pd_ui_integration_client;
